import { useContext } from 'react';
import { parseISO } from 'date-fns';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { eventCalendarDisplayableDate } from 'components/EventCalendarPage/event-calendar-page-utils';
import { Button } from 'components/UI/Button/Button';
import { EventFiltersContext } from 'components/Shared/EventFiltersProvider';

export const EventCalendarEventsResults = () => {
  const { eventsData, pageNum, setPageNum, isBusy, setIsBusy } = useContext(EventFiltersContext);

  const groupEventsByDate = () =>
    eventsData?.events.reduce((groupedEventsArray, currentEvent) => {
      groupedEventsArray[currentEvent.eventDateValue] = [
        ...(groupedEventsArray[currentEvent.eventDateValue] || []),
        currentEvent,
      ];
      return groupedEventsArray;
    }, []);

  const groupedEventsWithTitle = () => {
    const eventsGroupedByDate = groupEventsByDate();

    return Object.keys(eventsGroupedByDate).map((dateKey) => {
      const eventsGroup = eventsGroupedByDate[dateKey];
      const parsedDate = parseISO(dateKey);
      const eventDateString = eventCalendarDisplayableDate(parsedDate);

      return (
        <div className="event-section" key={dateKey}>
          <h2 className="h3 section-title">{eventDateString}</h2>
          <EventTileGroup collapseOnMobile>
            {eventsGroup?.map((event) => (
              <EventTile {...event} key={event.id} collapseOnMobile />
            ))}
          </EventTileGroup>
        </div>
      );
    });
  };

  const loadMoreEventsButtonHandler = () => {
    setIsBusy(true);
    setPageNum((prevPageNum) => prevPageNum + 1);
  };

  const loadMoreButton = (pageNum < eventsData.totalPages || isBusy) && (
    <div className="fullwidth-container text-center">
      <Button
        onClick={loadMoreEventsButtonHandler}
        variant="primary"
        extendClass={`btn-small load-more-events btn-loading ${isBusy ? 'component-loading' : ''}`}
        disabled={isBusy}
      >
        <div className="loading-overlay btn-loading-overlay">
          <div className="loading">LOADING</div>
        </div>
        Load more events
      </Button>
    </div>
  );

  return (
    <>
      {groupedEventsWithTitle()}
      {loadMoreButton}
    </>
  );
};
